import type { GetServerSideProps, InferGetServerSidePropsType, NextPage } from 'next';
import { GetServerSidePropsContext } from 'next/types';

import MainLayout from '@layouts/main-layout/main-layout';
import ProjectsComponent from '@components/projects/projects';
import { getProjects } from '@services/project.service';
import Head from 'next/head';
import { MetaTags } from '@helpers/meta-tags.helper';
import { config } from '../../config';

const Projects: NextPage = ({ projects, total }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
    return (
        <>
            <Head>{
                MetaTags({
                    title: 'Software Development Case Studies & Success Stories | Agilie.',
                    description: 'Explore our real-world software development success stories. See how Agilie helps businesses solve challenges and build scalable digital products.',
                    imageUrl: '/success-stories/success-stories-image-meta.png'
                })
            }
                <link rel="icon" href="/favicon.ico" />
            </Head>
            <MainLayout>
                <ProjectsComponent projects={projects} total={total} />
            </MainLayout>
        </>
    )
}

export default Projects;

export const getServerSideProps: GetServerSideProps = async (context: GetServerSidePropsContext) => {
    const { data, total } = await getProjects(0, 6);
    return {
        props: {
            projects: data,
            total: total
        }
    }
}